module.exports = __webpack_public_path__ + "static/media/PortraitLeaderboard-10043.f06c0161.jpg";